import { createStructuredSelector } from 'reselect';

export const selectParameters = (state) => state.wsp?.parameters;
export const selectQuote = (state) => state.wsp?.quote;
export const selectValidatorFlag = (state) => state.wsp?.validatorFlag;
export const selectVariantId = (state) => state.wsp?.variantId;
export const selectQuantity = (state) => state.wsp?.quantity;
export const selectAddingToCart = (state) => state.wsp?.addingToCart;

export const selectDataForCart = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  variantId: selectVariantId,
  quantity: selectQuantity,
  addingToCart: selectAddingToCart
});

export const selectDataForApp = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  validatorFlag: selectValidatorFlag
});